
var firestore = require('../firestore')
var to = require('await-to-js').default
async function createDocument(userToken,collection, document){
    let err, res;
    
    [err, res] = await to(firestore.createDocument(userToken,collection ,document))
    if (err){
        console.error(err.response)
        throw err
    }
    else if(res){
        console.log(res)
        return res
    }
}

async function getDocument(collection, query){
    let err, res;
    
    [err, res] = await to(firestore.getDocument(collection ,query))
    if (err){
        console.error(err.response)
        throw err
    }
    else if(res){
        console.log(res)
        return res
    }
}

async function getDocumentByPath(userToken, documentPath){
    let err, res;
    
    [err, res] = await to(firestore.getDocumentByPath(userToken,documentPath))
    if (err){
        console.error(err.response)
        throw err
    }
    else if(res){
        console.log(res)
        return res
    }
}

async function updateDocument(userToken, documentPath, body){
    let err, res;
    
    [err, res] = await to(firestore.updateDocument(userToken,documentPath ,body))
    if (err){
        console.error(err.response)
        throw err
    }
    else if(res){
        console.log(res)
        return res
    }
}

async function deleteDocument(userToken, documentPath){
    let err, res;
    
    [err, res] = await to(firestore.deleteDocument(userToken, documentPath))
    if (err){
        console.error(err.response)
        throw err
    }
    else if(res){
        console.log(res)
        return res
    }
}


module.exports = {createDocument, getDocumentByPath, getDocument, updateDocument, deleteDocument}


// WEBPACK FOOTER //
// ./src/services/database/database.js